import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Button
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
//Import Breadcrumb
import Breadcrumb_2Items from "../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../helpers/forms_helper";
import preloader from "../../../helpers/preloader";
import showNotification from "../../../helpers/show_notification";
import printDiv from "../../../helpers/print_data";

const ViewInventory = (props) => {
  const { SearchBar } = Search;


  useEffect(() => {
    loadAllStores();
  }, []);

  const [allStores, setAllStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState("All");
  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter((store)=>store.type !== "EQUIPMENT STORE" )
      setAllStores(res);
    } else {
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    loadAllEquipments();
  }, [selectedStore]);

  const [allEquipments, setAllEquipments] = useState([]);
  const loadAllEquipments = async () => {
   try {
    preloader(true)
    let payload = {store_id:selectedStore};   
    let url = process.env.REACT_APP_BASEURL + "storeequipmentinventories/get_by_store_id";
    const response = await postSubmitForm(url, payload);
    if (response && response.status === 1) {
      preloader(false)
      setAllEquipments(response.data);
    } else {
      showNotification(response.message, "Error");
    }
   } catch (error) {
    preloader(false)
    showNotification(error,"Error")
   } finally{preloader(false)}
  };

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "_id",
      formatter: (cell, row, rowIndex) => {
        return rowIndex + 1;
      },
      text: props.t("#"),
      headerStyle: (colum, colIndex) => {
        return { width: "3%" };
      },
    },
    {
      text: props.t("Store"),
      dataField: "store_name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      text: props.t("Equipment"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    // {
    //   text: props.t("Batch"),
    //   dataField: "batch",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },
    {
      dataField: "category",
      text: props.t("Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  
    {
      dataField: "threshold",
      text: props.t("Threshold"),
      sort: true,
      formatter:(cell,row)=>{
         return row.threshold+" "+row.unit
      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "available_in_unit",
      text: props.t("Available"),
      sort: true,
      formatter:(cell,row)=>{
        return row.available_in_unit < row.threshold ? (
          <span className="font-size-12 badge-soft-danger badge badge-danger badge-pill mr-1 mb-1">
            {row.available_in_unit + " " + row.unit}
          </span>
            ) : (
              <>
               {row.available_in_unit + " " + row.unit}

              </>
            );      },
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },

  ];

  const handleDownload = async () => {
    const fileName = "branch_equipment_inventory";
    const exportType = "xls";

    let data_to_export = allEquipments;

    if (data_to_export) {
      var data = [];
      JSON.parse(JSON.stringify(data_to_export)).forEach(function (v) {
        data.push({
          Store: v.store_name,
          // Batch: v.batch,
          Equipment: v.name,
          category: v.category,
          sub_category: v.sub_category,
          threshold: v.threshold,
          unit: v.unit,
          Available: v.available_in_unit,
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Equipments")}
            title={props.t("Equipment Store")}
            breadcrumbItem1={props.t("Branch/Store Inventory")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <AvForm>
                    <CardTitle>{props.t("Branch/Store Inventory")} </CardTitle>
                    <CardSubtitle className="mb-3">
                      {props.t("Select a store or branch to view its inventory")}
                    </CardSubtitle>
                    <Row>
                      <Col lg={6}>
                        <AvField
                          name="branch"
                          label={props.t("Select Branch/Store")}
                          type="select"
                          value={selectedStore}
                          errorMessage={props.t("Branch or Store cannot be empty")}
                          onChange={(e) => {
                            setSelectedStore(e.target.value);
                          }}
                        >
                          <option value="All">{props.t("All")}</option>
                          {allStores &&
                            allStores.map((e) => (
                              <option key={e._id} value={e._id} name={e.name}>
                                {e.name}
                              </option>
                            ))}
                        </AvField>
                      </Col>
                    </Row>
                    {/* <Button type="submit">Submit</Button> */}
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {/* <CardTitle>{props.t("Branch Inventory")} </CardTitle>
                  <CardSubtitle className="mb-3">
                    {props.t("Select a branch to view its inventory")}
                  </CardSubtitle> */}
                  <Row className="mb-2">
                    <Col sm="4">
                      <Button
                        type="submit"
                        className="btn btn-sm btn-secondary"
                        onClick={handleDownload}
                      >
                        <i className="mdi mdi-file-export"></i>{" "}
                        {props.t("Export CSV")}
                      </Button>
                      {"  "}
                      <Link
                        to="#"
                        onClick={() => {
                          printDiv("Equipments_Inventory");
                        }}
                        className="btn btn-sm btn-success mr-2"
                      >
                        <i className="fa fa-print"></i> Print
                      </Link>
                      <div className="search-box mr-2 mb-2 d-inline-block">
                        <div className="position-relative"></div>
                      </div>
                    </Col>
                  </Row>
                  <div id="Equipments_Inventory">
                    <ToolkitProvider
                      bootstrap4
                      keyField="_id"
                      data={allEquipments && allEquipments}
                      columns={columns}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <Row>
                            <Col lg={4}>
                              <SearchBar
                                {...props.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4} className="text-center">
                              <CardTitle>Branch/Store Equipment Inventory</CardTitle>
                            </Col>
                            <Col lg={4}> </Col>
                          </Row>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            //pagination={paginationFactory(pagination_options)}
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                  </div>

                  {/* <div>
                    <br />

                    {[...Array(pageCount)].map((x, i) => (
                      <button
                        key={i}
                        onClick={() => {
                          setPageNumber(i + 1);
                        }}
                        className={
                          pageNumber === i + 1 ? "btn btn-primary" : "btn"
                        }
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ViewInventory))
);
